module.exports = __webpack_public_path__ + "static/media/header_ico_home.975c67fc.svg";